jQuery(document).ready(function ($) {
    var $slide = $('.home-slide .swiper-container');

    if (!$slide.length) return

    var mySwiper = new Swiper($slide, {
        autoplay: {
            delay: 7000,
        },
        speed: 550,
        spaceBetween: 50,
        pagination: {
            el: '.slide-navigation',
            clickable: true,
            bulletClass: 'bullet',
            bulletActiveClass: 'bullet-active',
            modifierClass: 'slide-pagination-'
        }
    });
});